import DefaultModal from 'components/common/DefaultModal';
import React from 'react';

import AvatarForm from './ProfileContent/AvatarForm';
import { ICreateAvatarModalProps } from './ProfileContent/types';

const UploadAvatarModal: React.FC<ICreateAvatarModalProps> = ({
  visible,
  onCloseModal,
  isCompanyAvatar,
  callbackOnUploadSuccess,
}) => (
  <DefaultModal
    props={{
      title: 'Upload new avatar',
      visible,
      destroyOnClose: true,
      maskClosable: false,
      closable: true,
      onCancel: onCloseModal,
    }}>
    <AvatarForm
      callbackOnUploadSuccess={callbackOnUploadSuccess}
      closeModal={onCloseModal}
      isCompanyAvatar={isCompanyAvatar}
    />
  </DefaultModal>
);

export default UploadAvatarModal;
